import axios from 'axios'
import {
    cutString,
    isNull,
} from '@/utils/main'
import moment from 'moment'

import {
    Notification,
} from 'element-ui'

const d = new Date()
// specialist
const localState = {
    data: [],
    specialist: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        phone: '',
        small_image: '',
        service: {
            color: '',
            name: '',
        },
        description: '',
        password: '',
        partner_id: '',
        partner: {},
        languages: [],
        birthday: null,
        is_inactive: false,
    },
    newSpecialist: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        phone: '',
        small_image: '',
        service: {
            color: '',
            name: '',
        },
        description: '',
        password: '',
        partner_id: '',
        partner: {},
        languages: [],
        birthday: null,
        is_inactive: false,
    },
    specialistFormData: {},
    services: [],
    formDataImg: {},
    request: {
        state: ' ',
        message: '',
    },
    specialistModal: false,
    specialistComments: null,
    search: '',
    selectData: '',
    deletion_tag: true,
    sortBy: '',
    orderBy: '',
    meta: {
        current_page: 0,
        last_page: null,
    },
    params: {
        partnerId: null,
    },
    partnersSetting: {
        placeholder: 'Partners',
        allowClear: false,
    },
    specialistImageFormData: null,
    created_id: null,
    specialistRequests: null,

    specialistRequestsMeta: {
        last_page: 1,
    },
    specialistCurrentPage: 1,
    isActive: 'list',

    scheduleMasterId: null,
    scheduleList: null,
    scheduleParams: {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
    },
    schedule: {
        date: {
            from: '',
            to: '',
        },
        time: {
            from: '09:00',
            to: '18:00',
        },

        days: [1, 2, 3, 4, 5],

    },
    editSchedule: {
        from: null,
        to: null,
        id: null,
        master_id: null,
        date: null,
    },
    recommendedMasters: null,
}

function isNotAll(item) {
    return item !== 'all'
}

function isObject(v) {
    return typeof v === 'object'
}

function getFilters(params) {
    let query = ''

    for (const item in params) {
        if (isObject(params[item]) && !isNull(params[item])) {
            // for params.shouldStartedFrom and params.shouldStartedTill
            if (
                !isNull(params[item].value)
                && params[item].hasOwnProperty('time')
                && !isNaN(params[item].time)
            ) {
                query += `${item}=${params[item].time}&`
            }
        }

        // if params.status !== null etc
        if (
            !isNull(params[item])
            && !isObject(params[item])
            && isNotAll(params[item])
        ) { query += `${item}=${params[item]}&` }
    }

    // if we don't have params => return ""
    // else cut the last character
    return query === '' ? '' : `&${cutString(query, 0, query.length - 1)}`
}

// function isNotLastPage(meta) {
//     return meta.current_page !== meta.last_page
// }

function getTags(tags) {
    let query = ''
    if (tags && tags.length > 0) {
        tags.forEach((element) => {
            query += `work_tags[]=${element.id}&`
        })
    }

    return query
}

const actions = {
    async getSpecialistsData({
        state,
        commit,
    }, {
        type,
        tags = [],
    }) {
        try {
            const filters = getFilters(state.params)
            let sort = `${state.sortBy}${state.orderBy}`
            sort = sort === '' ? '' : `${sort}&`
            const _tags = getTags(tags)
            const response = await this.$api.specialists.fetch({
                type,
                filters,
                sort,
                tags: _tags,
            })

            commit('addAllServices', {
                data: response.data.data !== undefined ? response.data.data : [],
            })
            commit('specialistsData', {
                data: response.data.data !== undefined ? response.data.data : [],
            })

            return response
        } catch (err) {
            console.log(err)
        }
    },
    async getSpecialist({
        state,
        commit,
    }, {
        id,
        type,
    }) {
        try {
            const response = await this.$api.specialists.fetchById({
                type,
                id,
            })

            commit('setSpecialist', response.data)

            state.request.state = ''
            state.request.message = ''

            return response
        } catch (err) {
            console.log(err)
        }
    },
    async getSpecialistRequests({
        state,
        commit,
    }, id) {
        try {
            const response = await this.$api.orders.fetchMasterRequests(id, state.specialistCurrentPage)

            commit('setRequestsMeta', response.data.meta || {
                last_page: 1,
            })

            return response.data.data || []
        } catch (err) {
            console.log(err)
        }
    },
    async getSpecialistSchedule({
        state,
        commit,
    }) {
        try {
            const response = await this.$api.specialists.schedule({
                ...state.scheduleParams,
                id: state.scheduleMasterId,
            })

            commit('setState', {
                type: 'scheduleList',
                data: response.data,
            })
        } catch (err) {
            console.log(err)
        }
    },
    async addSchedule({
        state,
        commit,
    }) {
        const response = await this.$api.specialists.addSchedule({
            ...state.schedule,
            date: {
                from: moment(state.schedule.date.from).format('YYYY-MM-DD'),
                to: moment(state.schedule.date.to).format('YYYY-MM-DD'),
            },
            master_id: state.scheduleMasterId,
        })

        if (response.status === 204) {
            commit('setState', {
                type: 'schedule',
                data: {
                    date: {
                        from: '',
                        to: '',
                    },
                    time: {
                        from: '',
                        to: '',
                    },

                    days: [1, 2, 3, 4, 5],
                },
            })

            return true
        }
    },

    async addScheduleById({
        state,
    }) {
        const response = await this.$api.specialists.addScheduleById(state.editSchedule)
        return response.status === 204
    },

    async updateScheduleById(_, params) {
        const response = await this.$api.specialists.updateSchedule(params)
        return response.status === 204
    },
    async deleteScheduleById(_, id) {
        const response = await this.$api.specialists.removeSchedule(id)
        return response.status === 204
    },

    async deleteScheduleAll({ state }) {
        const response = await this.$api.specialists.removeScheduleAll({
            ...state.scheduleParams,
            id: state.scheduleMasterId,
        })

        return response.status === 204
    },
    // scheduleList
    addSpecialist({
        state,
        dispatch,
        commit,
    }, {
        type,
    }) {
        return new Promise((resolve, reject) => {
            commit('specialistForm', {
                data: state.newSpecialist,
            })

            if (state.specialistFormData.partner_id === '') {
                delete state.specialistFormData.partner_id
            }

            this.dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .post(`/${type}`, state.specialistFormData, window.requestConfig)
                    .then((res) => {
                        this.dispatch('specialists/getSpecialistsData', {
                            type,
                        })

                        if (state.newSpecialist.big_image) {
                            dispatch('updateSpecialistAvatar', {
                                id: res.data.id,
                                data: state.specialistImageFormData,
                                type,
                            })
                        }

                        state.newSpecialist = {
                            big_image: '',
                            email: '',
                            first_name: '',
                            id: '',
                            last_name: '',
                            phone: '',
                            small_image: '',
                            service: {
                                color: '',
                                name: '',
                            },
                            description: '',
                            password: '',
                            partner_id: '',
                            partner: {},
                            languages: [],
                            birthday: null,
                        }
                        commit('setState', {
                            type: 'created_id',
                            data: res.data.id,
                        })

                        resolve(res)
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        } else if (err.response.status === 422) {
                            Notification({
                                title: 'error 404',
                                message: err.response.data.fields[0].message,
                                duration: 5000,
                            })
                        } else if (err.response.status === 500) {
                            Notification({
                                title: 'Server technical works',
                                message: 'We\'re sorry. We have technical works',
                                duration: 2000,
                            })
                        }
                        reject()
                    })
            })
        })
    },
    editSpecialist({
        state,
        commit,
    }, {
        id,
        type,
    }) {
        return new Promise((resolve, reject) => {
            commit('specialistForm', {
                data: state.specialist,
            })

            this.dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .put(`/masters/${id}`, state.specialistFormData, window.requestConfig)
                    .then((res) => {
                        this.dispatch('specialists/getSpecialistsData', {
                            type,
                        })

                        resolve(res.status === 200)
                    })
                    .catch((err) => {
                        if (err.response.status === 422) {
                            Notification({
                                title: 'Validation failed',
                                message: err.response.data.fields[0].message,
                                duration: 5000,
                            })
                        }
                        if (err.response.status === 500) {
                            Notification({
                                title: 'Server technical works',
                                message: 'We\'re sorry. We have technical works',
                                duration: 2000,
                            })
                        }
                        reject()
                    })
            })
        })
    },
    async updateSpecialistAvatar(_, {
        id,
        type,
        data,
    }) {
        try {
            await this.$api.specialists.uploadImage(id, data)
            this.dispatch('specialists/getSpecialistsData', {
                type,
            })
        } catch (err) {
            console.log(err)
        }
    // const headers = {
    //   "Content-type": "multipart/form-data",
    // };
    // axios
    //   .post(`${globalConfig.baseUrl}/${type}/${id}/image`, data, headers)
    //   .then((res) => {
    // this.dispatch("specialists/getSpecialistsData", {
    //   type,
    // });
    //   })
    //   .catch((err) => {
    //     if (err.response.status === 401) {
    //       dispatch("resetSession");
    //     }
    //   });
    },
    deleteSpecialist(_, {
        id,
        type,
    }) {
        return new Promise((resolve) => {
            this.dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .delete(`/${type}/${id}`, window.requestConfig)
                    .then((res) => {
                        this.dispatch('specialists/getSpecialistsData', {
                            type,
                        })
                        resolve(res)
                    })
                    .catch((err) => {
                        resolve(err.response)
                    })
                // .catch(err => {
                // if (err.response.status === 401) {
                // dispatch('resetSession');
                // } else if (err.response.status === 400) {
                // commit('setError', err.response);
                // }
                // reject();
                // });
            })
        })
    },
    async fetchComments({
        commit,
    }, {
        type,
        id,
    }) {
        try {
            const response = await this.$api.specialists.comments({
                type,
                id,
            })
            commit('setSpecialistComments', response.data.data)
        } catch (err) {
            console.log(err)
        }
    },
    async getSpecialistByPhoneNumber(_, {
        word = '',
    }) {
        let query = ''
        if (word !== null) {
            query = `?search=${word}`
        }

        const response = await this.$api.specialists.fetchByPhone(query)
        return response.data
    },

    async addSkills(_, {
        id,
        form,
    }) {
        return await this.$api.specialists.addSkills(id, form)
    },

    async getSkills(_, id) {
        return await this.$api.specialists.getSkills(id)
    },

    async addTools(_, {
        id,
        form,
    }) {
        return await this.$api.specialists.addTools(id, form)
    },

    async getTools(_, id) {
        return await this.$api.specialists.getTools(id)
    },

    async fetchRecommendedMasters({
        commit,
    }, form) {
        const response = await this.$api.specialists.fetchRecommendedMasters(form)
        commit('setRecommendedMasters', response.status !== 200 ? [] : response.data)
    },
}

const mutations = {
    setState(state, {
        type,
        data,
    }) {
        state[type] = data
    },
    clearSchedule: (state) => {
        state.schedule = {
            date: {
                from: '',
                to: '',
            },
            time: {
                from: '09:00',
                to: '18:00',
            },

            days: [1, 2, 3, 4, 5],
            master_id: null,
            datetime: null,
        }
    },
    setRecommendedMasters: (state, v) => {
        state.recommendedMasters = v
    },
    setEditSchedule: (state, v) => {
        state.editSchedule.date = v.date
        state.editSchedule.master_id = v.master_id
        state.editSchedule.to = v.to
        state.editSchedule.from = v.from
        state.editSchedule.id = v.id
    },
    resetRequestsPage: (state) => {
        state.specialistCurrentPage = 1
    },
    setRequests(state, data) {
        state.specialistRequests = data
    },
    addRequests(state, data) {
        state.specialistRequests = [...state.specialistRequests, ...data]
    },
    setSearch: (state, v) => {
        state.search = v
    },
    setSelectData: (state, v) => {
        state.selectData = v
    },
    setSpecialistComments: (state, v) => {
        state.specialistComments = v
    },
    addAllServices(state, {
        data,
    }) {
        const services = []

        data.forEach((el) => {
            services.push(el.service.name)
        })

        state.services = services
    },
    specialistsData(state, {
        data,
    }) {
        state.data = data
    },
    specialistForm(state, {
        data,
    }) {
        const specialistData = {
            first_name: data.first_name,
            last_name: data.last_name,
            service_id: data.service.id,
            phone: data.phone,
            email: data.email,
            password: data.password,
            description: data.description,
            birthday: data.birthday !== null ? moment(data.birthday).format('Y-M-D') : null,
            languages: data.languages || [],
            office_id: data.office_id || '',
            is_inactive: data.is_inactive,
        }

        if (data.partner !== null && data.partner !== undefined) {
            if (data.partner.id !== null) {
                specialistData.partner_id = data.partner.id
            }
        }

        if (data.specialistData === false) {
            delete specialistData.password
        }

        if (data.partner_id !== null) {
            specialistData.partner_id = data.partner_id
        }

        state.specialistFormData = specialistData
    },
    setAvatarSpecialist(state, {
        data,
    }) {
        state.specialist.big_image = data
    // if (type === 'add') {
    // state.newEngineer.big_image = data;
    // state.newEngineer.small_image = data;
    // } else {
    // state.engineer.big_image = data;
    // state.engineer.small_image = data;
    // }
    },
    udpateObject(state, {
        data,
    }) {
        for (const key in state[data]) {
            state[data][key] = ''
        }
    },
    setSpecialistModal: (state) => {
        state.specialistModal = !state.specialistModal
    },
    setDeletionStatus: (state, v) => {
        state.deletion_tag = v
    },

    setSort: (state, {
        sortBy,
        orderBy,
    }) => {
        state.sortBy = sortBy
        state.orderBy = orderBy
    },
    setMeta: (state, v) => {
        state.meta = v
    },
    incPage: (state, v) => {
        state.meta.current_page = v === null ? ++state.meta.current_page : v
    },
    setParams: (state, v) => {
        state.params = v
    },
    clearFormData: (state) => {
        state.specialistFormData = {
            first_name: '',
            last_name: '',
            service_id: '',
            phone: '',
            email: '',
            password: '',
            description: '',
            languages: [],
            birthday: null,
            office_id: '',
        }
    },
    clearNewForm: (state) => {
        state.newSpecialist = {
            big_image: '',
            email: '',
            first_name: '',
            id: '',
            last_name: '',
            phone: '',
            small_image: '',
            service: {
                color: '',
                name: '',
            },
            description: '',
            password: '',
            partner_id: '',
            partner: {},
            languages: [],
            birthday: null,
        }
    },
    clearParams: (state) => {
        state.params = {
            partnerId: null,
        }
    },
    setSpecialist: (state, v) => {
        state.specialist = v

        if (state.specialist.languages === null) {
            state.specialist.languages = []
        }

        if (v.office) {
            state.specialist.office_id = v.office.id
        }
    },
    setSpecialistImageFormData: (state, fd) => {
        state.specialistImageFormData = fd
    },
    setRequestsMeta: (state, meta) => {
        state.specialistRequestsMeta = meta
    },
    incSpecialistCurrentPage: (state) => {
        state.specialistCurrentPage += 1
    },
    clearScheduleParams: (state) => {
        state.scheduleParams = {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
        }
    },
}

const getters = {
    getSpecialists: (state) => state.data,
    getSpecialist: (state) => state.specialist,
    getNewSpecialist: (state) => state.newSpecialist,
    gettersSpecialistModal: (state) => state.specialistModal,
    specialistCommentsGetters: (state) => state.specialistComments,
    searchGetters: (state) => state.search,
    selectDataGetters: (state) => state.selectData,
    deletionStatusGetters: (state) => state.deletion_tag,
    partnersSettingGetters: (state) => state.partnersSetting,
    paramsGetters: (state) => state.params,
    created_id: (state) => state.created_id,
    specialistRequests: (state) => state.specialistRequests,
    isLastPage: (state) => state.specialistRequestsMeta.last_page === state.specialistCurrentPage,
    isActive: (state) => state.isActive,
    scheduleMasterId: (state) => state.scheduleMasterId,
    scheduleList: (state) => state.scheduleList,
    scheduleParams: (state) => state.scheduleParams,
    schedule: (state) => state.schedule,
    editSchedule: (state) => state.editSchedule,
}

export default {
    namespaced: true,
    state: localState,
    getters,
    actions,
    mutations,
}
